import { Edit, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";

const EditHealthcareCampaign = () => {
  return (
    <Edit
      title="Редактиране на кампания за здравни грижи"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
      transform={({ id, courses, createdOn, createdByUserId, ...rest }) => rest}
    >
      <SimpleForm
        toolbar={<InactiveDeleteOptionEditToolbar />}
        defaultValues={record => ({
          ...record,
          courseIds: record?.courses?.map(c => c.id) ?? [],
        })}
      >
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditHealthcareCampaign;
